

class ArticleModal {
  constructor(ajaxUrl) {
    this.ajaxUrl = ajaxUrl;
  }

  fetchArticle(slug) {
    var fetch = window.fetch;
    var filters = filters || [];
    var requestUrl = this.ajaxUrl + '?action=theme:single-article';
    requestUrl += '&slug=' + slug;
    var request = new window.Request(requestUrl);

    return fetch(request)
      .then(function(response) {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(this.fetchPageComplete);
  }

  fetchPageComplete(response) {
    return (response && response.data) ? response.data : null;
  }
}

var articleModalService = new ArticleModal(window.SBM.ajaxUrl);


export default articleModalService;

